import { CORE_PATH } from '@shared/api/paths';
import { instance } from '@shared/api/config';
import { ServiceGroupApplication } from '@shared/types/serviceGroupApplications';

// OSI-822: заявки на добавление/переименование произвольных групп услуг (модерация в админке).
// instance (shared/api/config.ts) при code !== 0 бросает СТРОКУ message, при успехе возвращает result.

const MAIN_PATH = 'ServiceGroupApplications';

const path = `${CORE_PATH}/${MAIN_PATH}`;

/** OSI-822: ключ react-query списка заявок ОСИ — по нему инвалидируем после создания/переименования группы. */
export const getServiceGroupApplicationsByOsiIdQueryKey = (osiId: number) => [path, 'by-osi', osiId] as const;

// OSI-822: при 401 интерцептор возвращает undefined — приводим к пустому списку, чтобы UI не падал на .filter.
export const getServiceGroupApplicationsByOsiId = async (osiId: number): Promise<ServiceGroupApplication[]> => {
  const result: ServiceGroupApplication[] | undefined = await instance.get(`${path}/by-osi/${osiId}`);
  return Array.isArray(result) ? result : [];
};
